import { Form, SubmitFormButton, TextField } from '@calendly/form';
import { object, string } from '@calendly/form/validation';
import { I18n } from '@calendly/i18n';
import { EMPTY_LINK } from '@calendly/rich-text-editor';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const fieldCss = "fyuumky";
const Field = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(fieldCss, props.className)} />);
const buttonContainerIsPhoneCss = "buhdd0h";
const buttonContainerCss = "b1tlhjfl";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isTablet = useDeviceType('isTablet');
  return <Component ref={ref} {...restProps} isTablet={isTablet} className={classNames(buttonContainerCss, {
    [buttonContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const InsertLinkPopup = ({
  isOpen,
  prefilledText,
  prefilledURL,
  onClose,
  onConfirm
}) => {
  const initialValues = {
    text: prefilledText,
    url: prefilledURL === EMPTY_LINK ? '' : prefilledURL
  };
  const validationSchema = object({
    url: string().required()
  });
  const handleConfirm = ({
    text,
    url
  }) => {
    onConfirm(text, url);
  };
  return <Popup isOpen={isOpen} onClose={onClose}>
      <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleConfirm}>
        <Body>
          <Field name="text" label={I18n.t('publisher.send_from_calendly.insert_link_popup.field.display_field_caption')} />
          <TextField name="url" label={I18n.t('publisher.send_from_calendly.insert_link_popup.field.link_field_caption')} disabled />
          <BodyText color="muted" size="small">{I18n.t('publisher.send_from_calendly.insert_link_popup.field.help_message')}</BodyText>
        </Body>
        <Footer>
          <ButtonContainer>
            <Button decoration="secondary-outline" onClick={onClose}>
              {I18n.t('publisher.send_from_calendly.insert_link_popup.action.cancel')}
            </Button>
            <SubmitFormButton>
              {I18n.t('publisher.send_from_calendly.insert_link_popup.action.confirm')}
            </SubmitFormButton>
          </ButtonContainer>
        </Footer>
      </Form>
    </Popup>;
};

require("./insert_link_popup.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./insert_link_popup.js");